import PersistenceInfo from "../../../../contents/docs/libraries/js/_snippets/persistence-info.mdx";
import * as React from 'react';
export default {
  PersistenceInfo,
  React
};